export default __webpack_public_path__ + "static/icon-749685f3be819b356ea2851aef8a2fb4.png";